import React, { useState } from 'react';

import axios from 'axios';
import modalIcon from 'images/icons/build/delete-icon.svg';
import InviteForm from './Invite/Popup';

import routes from '../../app/routes';
import Tooltip from '../ui/Tooltip';
import ModalWithoutTitle from '../ui/ModalWithoutTitle';

export default function TableItemActions({ row, updateCollection, teamId }) {
  const [managerForInvite, setManagerForInvite] = useState(null);
  const [managerForDelete, setManagerForDelete] = useState(null);
  const [checkboxDeleteMember, setCheckboxDeleteMember] = useState(null);

  const editManagerUrl = (id) => routes.api.team_leads.edit(id);

  const deleteAction = () => {
    axios
      .delete(routes.api.team_leads.destroy(row.id), { data: { delete_member: checkboxDeleteMember } })
      .then(() => updateCollection());
  };

  const deleteManager = () => {
    setManagerForDelete(row);
  };

  const inviteMember = (row) => {
    setManagerForInvite(row);
  };

  return (
    <>
      <a
        href={editManagerUrl(row.id)}
        className="btn btn-primary"
        data-tip="Edit Users Profile / Change Status"
        target="_blank"
        rel="noreferrer"
      >
        <i className="fa fa-fw fa-edit" />
      </a>
      <a
        href={routes.api.users.impersonate(row.attributes.user_id)}
        className="btn btn-info ml5"
        data-tip="Login as User"
      >
        <i className="fa fa-fw fa-user-secret" />
      </a>
      <a
        onClick={() => inviteMember(row)}
        className="btn btn-info ml5"
        data-tip="Send Invite"
      >
        <i className="fa fa-fw fa-paper-plane" />
      </a>
      <a
        onClick={() => deleteManager()}
        className="btn btn-danger ml5"
        data-tip="Delete Manager"
      >
        <i className="fa fa-fw fa-trash" />
      </a>
      <InviteForm
        manager={managerForInvite}
        closeForm={() => setManagerForInvite(null)}
      />
      <ModalWithoutTitle show={managerForDelete != null} onHide={() => setManagerForDelete(null)}>
        <div className="build_program-modal create_program-modal">
          <div className="programModal_logo">
            <img src={modalIcon} alt="logo" />
          </div>
          <div className="programModal_title text-h3">Delete Manager</div>

          <div className="programModal_txt">
            <p>Do you really want to delete this manager?</p>
            <div className="checkbox">
              <label>
                <input
                  type="checkbox"
                  value={checkboxDeleteMember}
                  onChange={() => setCheckboxDeleteMember(!checkboxDeleteMember)}
                />
                Delete Manager’s Member Account
                <abbr
                  className="ml5"
                  title="Members with programs assigned or in progress will
                be moved to request to delete list."
                >
                  *
                </abbr>
              </label>
            </div>
          </div>
          <div>
            <button
              onClick={() => setManagerForDelete(null)}
              type="button"
              className="btn btn-green btn-outline w-100 mr5"
            >
              Cancel
            </button>
            <button onClick={() => deleteAction()} type="button" className="btn btn-green w-100 ml5">Delete</button>
          </div>
        </div>
      </ModalWithoutTitle>
      <Tooltip />
    </>
  );
}
